import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "~/App";
import AuthenticatorProvider from "~/AuthenticationProvider";
import MarketplaceProvider from "~/MarketplaceProvider";
import analyticsService from "~/services/AnalyticsService";
import loggingService from "~/services/LoggingService";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LicenseInfo } from "@mui/x-license";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

const queryClient = new QueryClient();

analyticsService.init();
loggingService.init();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-us">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={BASENAME ? BASENAME : undefined}>
          <AuthenticatorProvider>
            <MarketplaceProvider>
              <App />
            </MarketplaceProvider>
          </AuthenticatorProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
